import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { cn } from '../../../utils/cn';

// Shared lists, fetched once per page load and reused by every line.
const cache = {};
function useList(url, key) {
  const [list, setList] = useState(cache[url] || []);
  useEffect(() => {
    if (cache[url]) return;
    api.get(url).then((r) => { cache[url] = r.data[key] || []; setList(cache[url]); }).catch(() => { cache[url] = []; });
  }, [url, key]);
  return list;
}
export const useItems = () => useList('/crm/accounting/items', 'items');
export const useCostCentres = () => useList('/crm/accounting/cost-centres', 'costCentres');
export function resetAccountingLists() { Object.keys(cache).forEach((k) => delete cache[k]); }

// Picks an item for a line; the caller decides which item fields to copy.
export default function ItemPicker({ value, onPick, className }) {
  const items = useItems();
  if (!items.length) return null;
  return (
    <select aria-label="Item" className={cn('h-9 px-2 bg-white border border-[#D8DDE6] rounded text-[12px] outline-none w-36', className)}
      value={value || ''} onChange={(e) => onPick(items.find((i) => i._id === e.target.value) || null)}>
      <option value="">Item…</option>
      {items.map((i) => <option key={i._id} value={i._id}>{i.name}{i.sku ? ` (${i.sku})` : ''}</option>)}
    </select>
  );
}

export function CostCentreSelect({ value, onChange, className, label = 'Cost centre' }) {
  const centres = useCostCentres();
  if (!centres.length) return null;
  return (
    <select aria-label={label} className={cn('h-9 px-2 bg-white border border-[#D8DDE6] rounded text-[12px] outline-none', className)} value={value || ''} onChange={(e) => onChange(e.target.value || null)}>
      <option value="">No cost centre</option>
      {centres.map((c) => <option key={c._id} value={c._id}>{c.name}</option>)}
    </select>
  );
}
